module.exports = __webpack_public_path__ + "2e911b0974f995ac75f4b45089fb4cd8.obj";